// @ts-nocheck
// get system notifications
export const GET_SYSTEM_NOTIFICATIONS_REQUEST =
  "GET_SYSTEM_NOTIFICATIONS_REQUEST";
export const GET_SYSTEM_NOTIFICATIONS_SUCCESS =
  "GET_SYSTEM_NOTIFICATIONS_SUCCESS";
export const GET_SYSTEM_NOTIFICATIONS_FAILURE =
  "GET_SYSTEM_NOTIFICATIONS_FAILURE";

// update system notifications
export const UPDATE_SYSTEM_NOTIFICATIONS_REQUEST =
  "UPDATE_SYSTEM_NOTIFICATIONS_REQUEST";
export const UPDATE_SYSTEM_NOTIFICATIONS_SUCCESS =
  "UPDATE_SYSTEM_NOTIFICATIONS_SUCCESS";
export const UPDATE_SYSTEM_NOTIFICATIONS_FAILURE =
  "UPDATE_SYSTEM_NOTIFICATIONS_FAILURE";